const defaultQueryParamsShipments = {
  limit: '20',
  page: '1',
  sortField: 'created_at',
  sortDirection: 'desc',
  relations: 'shipmentExtraCosts|shipmentStatus|shipmentItems|warehouse',
};

export const PurchaseOrderConfig = {
  defaultQueryParamsShipments,
};
